import * as React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import Loader from '~/common/components/Loader';
import FooterWrapper from '~/common/elements/mobile/FooterWrapper';
import FormikForm from '~/lib/forms/FormikForm';
import Button from '~/common/elements/mobile/Button';
import { getSaleById } from '~/apps/pos/shared/actions/sales';
import { navigate } from '~/router';
import { currency, timeStamp } from '~/lib/formatters';
import {
  getPaymentName,
  getSaleStatusName,
  getStatusClasses,
  isRemoteCheckout,
  SaleStatus,
} from '~/apps/pos/shared/services/helpers';
import { printPdf, printSaleById } from '~/apps/pos/shared/services/print';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import { emailRegExp, Features, phoneRegExp } from '~/apps/shared/consts';
import SaleFormEmailOrSms, { sendToName } from '~/apps/pos/mobile/components/sales/SaleFormEmailOrSms';
import { sendMessageEmail, sendMessageSMS } from '~/apps/pos/shared/actions/message';
import {createRouteNodeSelector} from "redux-router5";
import {parseSaleStatusFilter} from "~/apps/pos/shared/services/qsfilter";
import {ReceiptType} from "~/apps/pos/consts";
import { getCompanyFieldLabel, getSaleNumber } from "~/apps/pos/helpers";
import {checkoutSendEmail, checkoutSendText} from "~/apps/pos/apis/message";

const saleSchema = Yup.object().shape({
  phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
  email: Yup.string().matches(emailRegExp, 'Email is not valid'),
});


class SaleViewMobile extends React.Component<any, any> {
  private refreshSaleInterval: NodeJS.Timeout;

  constructor(props) {
    super(props);

    this.state = {
      sendTo: null,
      errorInfo: {
        isError: false,
        message: '',
      },
      sendStatus: null,
      isSending: false,
    }
  }

  componentDidMount(): void {
    const {dispatch, saleId} = this.props;
    dispatch(getSaleById(saleId)).then(() => {
      const sale = this.props.sales[saleId];

      if (sale && sale.status === SaleStatus.PAYMENT_PROCESSING.key) {
        this.refreshSaleInterval = setInterval(() => {
          dispatch(getSaleById(saleId));
        }, 30000)
      }
    });
  }

  componentWillUnmount() {
    if (this.refreshSaleInterval) clearInterval(this.refreshSaleInterval);
  }

  setSendTo = (value) => {
    this.setState({
      sendTo: value,
    });
  };

  setInfoMessage = (value) => {
    this.setState({
      errorInfo: value,
    });
  };

  clearMessage = () => {
    this.setInfoMessage({
      isError: false,
      message: '',
    });
  };

  handleActions = (actionKey) => {
    const { sales, saleId, filter: {q, status}, features } = this.props;
    const sale = sales[saleId];

    switch (actionKey) {
      case 'receipt-print':
        if (sale) {
          const useUsualPrinters = features.includes(Features.USE_USUAL_PRINTERS);
          printSaleById(saleId, useUsualPrinters);
        }

        break;
      case 'receipt-url':
        if (sale && sale.receiptUrl) {
          window.open(sale.receiptUrl);
        }
        break;
      case 'history':
        navigate('pos.mobile.history', {q, status});
        break;
      case 'new-sale':
        navigate('pos.mobile.createSale');
        break;
      case 'on-click-right': {
        const { onHelp } = this.props;
        if (onHelp) onHelp();
      }
        break;
      default:
        console.warn(`>>> Not action key: ${actionKey} !!!`)
    }
  };

  cbResponse = (result) => {
    if (result.isError) {
      this.setInfoMessage({
        isError: true,
        message: result.message,
      });
    } else {
      this.setInfoMessage({
        isError: false,
        message: result.message,
      });
    }
  };

  handleSendAction = (action, options) => {
    const {filter: {q, status}} = this.props;
    const saleResult = this.state.result;

    switch (action) {
      case 'receipt-print':
        if (saleResult && saleResult.receiptUrl) {
          printPdf(saleResult.receiptUrl);
        }
        break;
      case 'request-sms':
        if (options && options.saleId && options.phone) {
          sendMessageSMS(options);
        }
        break;
      case 'request-email':
        if (options && options.saleId && options.email) {
          sendMessageEmail(options);
        }
        break;
      case 'result-done':
        navigate('pos.mobile.history', {q, status});
        break;
      default:
        console.warn(`Not button action: ${action} !!!`);
    }
  };

  handleSendsSelect = (action, options = {}) => {
    switch (action) {
      case 'receipt-text':
        this.clearMessage();
        this.setSendTo(sendToName.SMS);
        break;

      case 'receipt-email':
        this.clearMessage();
        this.setSendTo(sendToName.MAIL);
        break;

      case 'send-to-sms':
        this.handleSendAction('request-sms', { ...options, cb: this.cbResponse });
        this.setSendTo(null);
        break;

      case 'send-to-email':
        this.handleSendAction('request-email', { ...options, cb: this.cbResponse });
        this.setSendTo(null);
        break;

      case 'cancel-send':
        this.setSendTo(null);
        break;

      default:
        break;
    }
  };

  getCheckoutLink = (sale, appUrl) => {
    if (!appUrl || !sale || !sale.paymentId
      || (sale.status !== SaleStatus.PAYMENT_PROCESSING.key && sale.status !== SaleStatus.PAYMENT_FAILED.key)
      || !isRemoteCheckout(sale.paymentType)) {
      return null
    }
    const absoluteLink = `${appUrl}/checkout/${sale.paymentId}/`;
    return (<a className='m__body__lbl__info' style={{wordWrap: 'break-word'}} href={absoluteLink} target="_blank">{absoluteLink}</a>);
  };

  handleSendText = () => {
    const { sales, saleId } = this.props;
    const sale = sales[saleId];

    this.setState({
      sendStatus: null,
      isSending: true,
    })

    checkoutSendText(sale.id)
      .then(() => {
        this.setState({
          sendStatus: true,
          isSending: false,
         })
      })
      .catch(() => {
        this.setState({
          sendStatus: false,
          isSending: false,
        })
      })
  };

  handleSendEmail = () => {
    const { sales, saleId } = this.props;
    const sale = sales[saleId];

    this.setState({
      sendStatus: null,
      isSending: true,
    })

    checkoutSendEmail(sale.id)
      .then(() => {
        this.setState({
          sendStatus: true,
          isSending: false,
        })
      })
      .catch(() => {
        this.setState({
          sendStatus: false,
          isSending: false,
        })
      })
  };

  renderSuccessMessage = () => (
    <div
      className="m__body__titl--lg"
      style={{
        color: "black",
        textTransform: "uppercase",
        fontSize: "2rem",
        fontWeight: "bold",
        marginTop: "2rem",
      }}
    >
      The message has been sent
    </div>
  );

  renderFailedMessage = () => (
    <div
      className="m__body__titl--lg"
      style={{
        color: "red",
        textTransform: "uppercase",
        fontSize: "2rem",
        marginTop: "2rem",
      }}
    >
      We were unable to resend a text, please try again later
    </div>
  );

  render() {
    const { sales, saleId, locations, loading, appUrl, currentUser, organizations, features } = this.props;
    const { errorInfo, sendTo, sendStatus, isSending } = this.state;
    const sale = sales[saleId];
    const isEmpty = !sale;
    const isAdditionalFields = sale && sale.additionalFields && typeof sale.additionalFields === 'object';
    const initialValues = {
      phone: '',
      email: '',
    };
    const isReceipt = sale && sale.status === SaleStatus.COMPLETED.key && sale.receiptUrl;
    const checkoutLink = this.getCheckoutLink(sale, appUrl);
    const currentOrg = organizations.entities[currentUser.organizationId];
    const hasDepartmentFeature = features.includes(Features.DEPARTMENTS);
    const hasHidePoNumberFeature = features.includes(Features.PO_NUMBER_NOT_REQUIRED);

    if (loading) {
      return (
        <Loader className="load--full" />
      );
    }

    if (!sale) return null;

    return (
      <FormikForm
        initialValues={initialValues}
        validationSchema={saleSchema}
        render={(propsForm) => {
          const { errors, values: { phone, email } } = propsForm;
          const isErrPhone = errors.hasOwnProperty('phone') || !phone;
          const isErrEmail = errors.hasOwnProperty('email') || !email;

          return (
            <PageMobileWrapper>
              {
                !isEmpty &&
                <div className="m__ol m__ol--dbtns">
                  <div className="m__head">
                    <span className="m__head__titl m__ol__titl">
                      Payment Details
                    </span>
                    <div className="m__head__right">
                      <Button
                        actionKey="history"
                        buttonStyle={buttonStyle.OL_CLOSE}
                        onClick={actionKey => {
                          this.handleActions(actionKey)
                        }}
                      >
                        <span className="i i-close-alt" />
                      </Button>
                    </div>
                  </div>

                  <div className="m__body app--md__box">
                    <div
                      className="col__cont"
                      style={isReceipt ? { height: 'calc(100% - 13rem)' } : { height: '100%' }}
                    >
                      <div className="col__row">
                        <div className="col col--half">

                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Price</div>
                            <div className="m__body__lbl__info">${currency(sale.price)}</div>
                          </div>
                          {!hasHidePoNumberFeature &&
                            <div className="m__body__info__block">
                              <div className="m__body__lbl">PO#</div>
                              <div className="m__body__lbl__info">{sale.poNumber}</div>
                            </div>
                          }
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">{getCompanyFieldLabel(features)}</div>
                            <div className="m__body__lbl__info">{sale.company}</div>
                          </div>

                          {
                            isAdditionalFields && Object.keys(sale.additionalFields).map(i => (
                              <div key={i} className="m__body__info__block">
                                <div className="m__body__lbl">{i}</div>
                                <div className="m__body__lbl__info">{sale.additionalFields[i]}</div>
                              </div>
                            ))
                          }
                          {sale.driverPhone &&
                            <div className="m__body__info__block">
                              <div className="m__body__lbl">Driver phone</div>
                              <div className="m__body__lbl__info">{sale.driverPhone}</div>
                            </div>
                          }
                          {features && features.includes(Features.ADD_COMPLETED_AT) && !!sale.completedAt &&
                            <div className="m__body__info__block">
                              <div className="m__body__lbl">Completed At</div>
                              <div className="m__body__lbl__info">{timeStamp(sale.completedAt)}</div>
                            </div>
                          }

                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Location</div>
                            <div
                              className="m__body__lbl__info">{locations.entities[sale.locationId] && locations.entities[sale.locationId].name}</div>
                          </div>
                        </div>
                        <div className="col col--half">

                          <div className="m__body__info__block">
                            <div className="m__body__lbl">#</div>
                            <div className="m__body__lbl__info">{getSaleNumber(sale, features)}</div>
                          </div>
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Status</div>
                            <div className="m__body__lbl__info">
                              <span className={getStatusClasses(sale.status)} style={{ 'cursor': 'default' }}>{getSaleStatusName(sale.status)}</span>
                            </div>
                          </div>
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Payment Type</div>
                            <div className="m__body__lbl__info">{getPaymentName(sale.paymentType)}</div>
                          </div>

                        </div>
                      </div>

                      <div className="col col--full">
                        {hasDepartmentFeature &&
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Department</div>
                            <div className="m__body__lbl__info">{sale.department && sale.department.name}</div>
                          </div>
                        }
                        {sale.shift &&
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Shift</div>
                            <div className="m__body__lbl__info">{sale.shift}</div>
                          </div>
                        }
                        <div className="m__body__info__block">
                          <div className="m__body__lbl">Notes</div>
                          <div className="m__body__lbl__info">{sale.description}</div>
                        </div>
                        {
                          checkoutLink &&
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Public link</div>
                            {checkoutLink}
                          </div>
                        }


                      </div>

                      {features && features.includes(Features.ARRIVAL_TIME_CHECK_IN_TIME) && <>
                        <br/><div className="col__row">
                        <div className="col col--half">
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Arrival Time</div>
                            <div className="m__body__lbl__info">{timeStamp(sale.arrivalTime)}</div>
                          </div>
                          <div className="m__body__info__block">
                            <div className="m__body__lbl">Check-in Time</div>
                            <div className="m__body__lbl__info">{timeStamp(sale.checkInTime)}</div>
                          </div>
                        </div>
                        <div className="col col--half">
                          {sale.notificationTime &&
                            <div className="m__body__info__block">
                              <div className="m__body__lbl">Notification Time</div>
                              <div className="m__body__lbl__info">{timeStamp(sale.notificationTime)}</div>
                            </div>
                          }
                          {sale.checkoutTime &&
                            <div className="m__body__info__block">
                              <div className="m__body__lbl">Checkout Time</div>
                              <div className="m__body__lbl__info">{timeStamp(sale.checkoutTime)}</div>
                            </div>
                          }
                        </div>
                      </div>
                      </>}

                      {isRemoteCheckout(sale.paymentType) && sale.status === SaleStatus.PAYMENT_PROCESSING.key && (
                        <>
                          {sendStatus === true && this.renderSuccessMessage()}
                          {sendStatus === false && this.renderFailedMessage()}
                          <div className="confirmation__send confirmation__send__light">
                            <h3 className="confirmation__send__heading">Resend the checkout link to the driver:</h3>
                            <div className="confirmation__send__buttons">
                              <Button
                                title="TEXT"
                                disabled={isSending}
                                onClick={this.handleSendText}
                                buttonStyle={buttonStyle.SECN}
                                buttonSize={buttonSize.LG}
                              />
                              <Button
                                title="Email"
                                disabled={isSending}
                                onClick={this.handleSendEmail}
                                buttonStyle={buttonStyle.SECN}
                                buttonSize={buttonSize.LG}
                              />
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>

                </div>
              }

              {isReceipt &&
                <FooterWrapper>
                  <div className="m__foot__btns">
                    {errorInfo.message ?
                      <p className={errorInfo.isError ? 'btn--tag--ti btn--warn' : 'btn--tag--ti btn--prim' }>{errorInfo.message}</p> : ''
                    }
                    <SaleFormEmailOrSms
                      sendTo={sendTo}
                      handleSends={this.handleSendsSelect}
                      options={{ saleId, phone, email }}
                      errorInfo={errorInfo}
                      isErrPhone={isErrPhone}
                      isErrEmail={isErrEmail}
                    />
                    {
                      !sendTo &&
                      <div className="m__foot__btns__dbl">
                        <Button
                          title="Send Text"
                          actionKey="receipt-text"
                          buttonStyle={buttonStyle.LARY}
                          buttonSize={buttonSize.LG}
                          onClick={(actionKey) => this.handleSendsSelect(actionKey)}
                        />
                        < Button
                          title="Send Email"
                          actionKey="receipt-email"
                          buttonStyle={buttonStyle.LARY}
                          buttonSize={buttonSize.LG}
                          onClick={(actionKey) => this.handleSendsSelect(actionKey)}
                        />
                      </div>
                    }
                    {
                      !sendTo && currentOrg.receiptType !== ReceiptType.ADAMS_FREIGHT_HANDLING ?
                        <div className="m__foot__btns__dbl">
                          <Button
                            title="View Receipt"
                            actionKey="receipt-url"
                            buttonStyle={buttonStyle.LARY}
                            buttonSize={buttonSize.LG}
                            onClick={actionKey => {
                              this.handleActions(actionKey)
                            }}
                          />
                          <Button
                            title="Print"
                            actionKey="receipt-print"
                            buttonStyle={buttonStyle.LARY}
                            buttonSize={buttonSize.LG}
                            onClick={actionKey => {
                              this.handleActions(actionKey)
                            }}
                          />
                        </div>
                        : !sendTo &&
                          <Button
                            title="View Receipt"
                            actionKey="receipt-url"
                            buttonStyle={buttonStyle.LARY}
                            buttonSize={buttonSize.LG}
                            onClick={actionKey => {
                              this.handleActions(actionKey)
                            }}
                          />
                    }
                  </div>
                </FooterWrapper>
              }
            </PageMobileWrapper>
          )
        }}
      />
    );
  }
}


const mapStateToProps = (state) => {
  const selector = createRouteNodeSelector('pos');
  const { route: { params } } = selector(state);

  const filter = parseSaleStatusFilter(params);
  return {
    sales: state.pos.sales.entities,
    loading: state.pos.sales.entities.loading,
    locations: state.shared.locations,
    appUrl: state.shared.information.entities.appUrl,
    currentUser: state.shared.auth.currentUser,
    organizations: state.shared.organizations,
    features: state.shared.information.entities.features,
    filter,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaleViewMobile);
